import React from 'react'

const Timeline = ({ steps }) => {
    return (
        <div className="space-y-4">
            {steps.map((step, index) => (
                <div key={index} className="flex gap-4">
                    <div className="flex flex-col items-center">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white ${
                            step.status === 'success' ? 'bg-emerald-500' :
                            step.status === 'error' ? 'bg-red-500' :
                            'bg-blue-500'
                        }`}>
                            {step.status === 'success' ? '✓' : step.status === 'error' ? '✗' : `${index + 1}`}
                        </div>
                        {index < steps.length - 1 && (
                            <div className="w-1 h-12 bg-gray-300 dark:bg-gray-600 my-1"></div>
                        )}
                    </div>
                    <div className="flex-1 pt-1">
                        <p className="font-medium text-sm">{step.title}</p>
                        <p className={`text-xs mt-1 ${
                            step.status === 'error' ? 'text-red-600 dark:text-red-400' : 'text-gray-600 dark:text-gray-400'
                        }`}>{step.message}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Timeline
